import {
  REQUEST_SHIP_STATEROOMS,
  RECEIVE_SHIP_STATEROOMS,
  SHIP_STATEROOMS_ERROR
} from '../actions/shipStateRooms'

const initialState = {
  isLoading: false,
  hasErrors: false,
  availableRooms: null
}
const shipStateRooms = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SHIP_STATEROOMS:
      return Object.assign({}, state, {
        isLoading: true
      })
    case RECEIVE_SHIP_STATEROOMS:
      return Object.assign({}, state, {
        availableRooms: action.payload,
        isLoading: false,
        hasErrors: false
      })
    case SHIP_STATEROOMS_ERROR:
      return Object.assign({}, state, {
        hasErrors: true
      })
    default:
      return state
  }
}

export default shipStateRooms
